import utils from 'utils'
class declareStockCtrl {
    constructor($scope, httpRequest, $q, logger, $http, querySort, initSortService, invoiceOpenService) {
        // 用户信息
        // const { userInfo } = $rootScope
        // 存储页面信息
        $scope.pageState = {
            userInfo: JSON.parse(localStorage.user_info)
        }

        // 字典数据
        $scope.dictData = {}
        const typecodeArrStr = '["ivat_inv_type","scan_type","tax_disk_type","inv_type","manage_type"]'
        const typecodeArr = ['ivat_inv_type', 'scan_type', 'tax_disk_type', 'inv_type', 'manage_type']
        const openApiInvType = [{enumTypeCode: 'inv_type', enumName: '专用发票', enumCode: '1', remark: ''}
            ,{enumTypeCode: 'inv_type', enumName: '普通发票', enumCode: '2', remark: ''},
            {enumTypeCode: 'inv_type', enumName: '机动车发票', enumCode: '3', remark: ''},
            {enumTypeCode: 'inv_type', enumName: '卷式发票', enumCode: '4', remark: ''},
            {enumTypeCode: 'inv_type', enumName: '电子普通发票', enumCode: '5', remark: ''},
            {enumTypeCode: 'inv_type', enumName: '电子专用发票', enumCode: '6', remark: ''},
            {enumTypeCode: 'inv_type', enumName: '二手车', enumCode: '7', remark: ''}]
        httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
            $scope.dictData = $.extend($scope.dictData, res.data.value)
            for (let i = 0, l = typecodeArr.length; i < l; i++) {
                const arr = $scope.dictData[typecodeArr[i]]
                arr.push({
                    enumTypeCode: null,
                    enumName: '全部',
                    enumCode: ''
                })
                arr.reverse()
                $scope.dictData[typecodeArr[i]] = arr
            }

            console.log($scope.dictData)
        })
        // 单机版金税盘信息
        // let singleInfo = {
        //     TaxCode: '',
        //     MachineNo: '',
        //     Kpfwqh: '',
        // }
        // 搜索中loading
        // let searching = null
        // 是否搜索中
        // let searched = false
        // let diskCodeArr = []
        // let ukeyCodeArr = []
        // 是否搜索队列结束
        // $scope.searchLoopDone = false
        $scope.ukeyList = JSON.parse(localStorage.user_info).sysUkeyList
        // 查询条件
        // 下拉开票机
        // $scope.queryDiskConfig = {
        //     queryName: 'ukeyName',
        //     queryKey: 'diskId',
        //     queryType: 'Flater',
        //     parentIdName: 'parentDiskId',
        //     multiple: true,
        //     parentId: 0,
        //     defaultSelect: [],
        // }
        // 下拉开票点
        // $scope.queryUkeyConfig = {
        //     queryName: 'ukeyName',
        //     queryKey: 'ukeyId',
        //     queryType: 'Flater',
        //     parentIdName: 'parentUkeyId',
        //     multiple: true,
        //     parentId: 0,
        //     defaultSelect: [],
        // }
        $scope.param = {
            pageNum: 1,
            pageSize: 10,
            param: {
                invoiceType: '',
                ukeyId: $scope.ukeyList[0].ukeyId
            },
        }
        $scope.reset = function () {
            $scope.param.param = {
                invoiceType: '',
                ukeyId: $scope.ukeyList[0].ukeyId
            }
            // $scope.queryDiskConfig.defaultSelect = defaultOrg
            // $scope.queryUkeyConfig.defaultSelect = []
        }
        // $scope.reset()
        // let defaultOrg = []
        // 表格数据
        $scope.resData = undefined
        $scope.resDataTotal = [] // 全部数据
        // 下拉数据
        // $scope.diskList = [] // 开票机数组
        // $scope.ukeyList = [] // 开票点
        // 组件配置


        // if (!$scope.pageState.userInfo.sale) {
        //     logger.logError('当前登录用户的机构没有销方信息')
        // } else {
        //     // 获取当前机构下所有机构
        //     httpRequest.get_getDiskBySaleId({
        //         saleId: $scope.pageState.userInfo.sale.saleId,
        //     }).then((res) => {
        //         $scope.diskList = res.data.value
        //         $scope.queryDiskConfig.defaultSelect = [].concat(res.data.value)
        //         defaultOrg = [].concat(res.data.value)
        //         // 默认全部
        //         $scope.param.param.diskCodeList = [].concat(res.data.value)
        //         diskCodeArr = $scope.param.param.diskCodeList.map((item) => item.diskCode)
        //         // 开票点
        //         httpRequest.post_getStockUkeyListByDiskCodes(diskCodeArr).then((res1) => {
        //             if (res1.data.success) {
        //                 $scope.ukeyList = toSelectData(res1.data.value, 'ukeyCode', 'ukeyName')
        //             }
        //         })
        //     })
        // }

        // 金税盘变化
        // $scope.diskSelectChange = function (v) {
        //     const diskSelectArr = v
        //     const diskSelectL = diskSelectArr.length
        //     if (diskSelectL > 0) {
        //         diskCodeArr = diskSelectArr.map((item) => item.diskCode)
        //         $scope.param.param.diskCodeList = v
        //     } else {
        //         $scope.param.param.diskCodeList = []
        //         diskCodeArr = []
        //     }
        //     $scope.param.param.ukeyCodeList = []
        //     $scope.queryUkeyConfig.defaultSelect = []
        //     httpRequest.post_getStockUkeyListByDiskCodes(diskCodeArr).then((res) => {
        //         if (res.data.success) {
        //             $scope.ukeyList = toSelectData(res.data.value, 'ukeyCode', 'ukeyName')
        //         }
        //     })
        // }


        // 开票点变化
        // $scope.ukeySelectChange = function (v) {
        //     const ukeySelectArr = v
        //     const ukeySelectL = ukeySelectArr.length
        //     if (ukeySelectL > 0) {
        //         ukeyCodeArr = ukeySelectArr.map((item) => item.ukeyCode)
        //         $scope.param.param.ukeyCodeList = v
        //     } else {
        //         $scope.param.param.ukeyCodeList = []
        //         ukeyCodeArr = []
        //     }
        // }

        // 组装新数组
        // function toSelectData(list, idfield, textfield, fielldtype) {
        //     const result = []
        //     for (const a in list) {
        //         const tempdata = {}
        //         $.extend(tempdata, list[a])
        //         tempdata[idfield] = list[a][idfield]
        //         tempdata[textfield] = list[a][textfield]
        //         result.push(tempdata)
        //     }
        //     return result
        // }


        // 默认查询值
        // $scope.profileType = '27'

        // 查询搜索字段和表格字段
        $scope.profileTypeObj = {
            version: 1,
            queryConfig: [{
                label: '发票种类',
                selected: true,
                default: true,
            }, {
                label: '开票机号',
                selected: true,
                default: true,
            }, {
                label: '开票点',
                selected: true,
                default: true,
            }, ],
            invTableLabel: [/*{
                label: '开票点',
                selected: true,
                default: true,
                labelContent: [{
                    labelWord: 'ukeyName'
                }],
            }, */{
                label: '发票种类',
                selected: true,
                default: true,
                labelContent: [{
                    labelWord: 'invType',
                    dictFilter: 'inv_type'
                }],
            }, {
                label: '类别代码',
                selected: true,
                default: true,
                labelContent: [{
                    labelWord: 'invoiceCode'
                }],
            }, {
                label: '起始号码',
                selected: true,
                default: true,
                labelContent: [{
                    labelWord: 'invoiceNumber'
                }],
            }, {
                label: '剩余张数',
                selected: true,
                default: true,
                labelContent: [{
                    labelWord: 'sum'
                }],
            }/*, {
                label: '金税盘类型',
                selected: true,
                default: true,
                labelContent: [{
                    labelWord: 'manageType',
                    dictFilter: 'manage_type'
                }],
            }, */],
        }


        // 分页数
        $scope.totalItems = 0 // 组件初始化设置总页

        // 查询列表
        $scope.queryTaxInfo = function () {
            $scope.resData = []
            $scope.resDataTotal = []
            utils.loading('数据查询中')
            var selectedDevice = null
            $scope.ukeyList.forEach((item) => {
                if(item.ukeyId == $scope.param.param.ukeyId){
                    selectedDevice = item
                }
            })
            if(selectedDevice.manageType==='3'){
                //新税控设备管理服务器A10
                //定义数据字典
                $scope.dictData['inv_type'] = openApiInvType
                var requestData = {
                    taxNo: $scope.pageState.userInfo.sale.saleCreditCode,
                    machineCode: selectedDevice.diskNo
                }
                httpRequest.post_queryDeviceStock(requestData).then((res)=>{
                    if(res.data.success){
                        const _resData = []
                        try{
                            $scope.totalItems = res.data.value.businessData.invoiceDetails.length
                            for (let i = 0; i < $scope.totalItems; i++) {
                                var _item = res.data.value.businessData.invoiceDetails[i]
                                var item = {
                                    ukeyName: '',
                                    invType: _item.invoiceCategory,
                                    invoiceCode: _item.categoryCode,
                                    invoiceNumber: _item.startNum,
                                    sum: _item.invoiceCount
                                }
                                _resData.push(item)
                            }
                            $scope.resData = _resData
                            $scope.selectedHandle(true)
                        }catch (e) {
                            console.log('处理异常' + e)
                        }
                    }
                    utils.loaded()
                },(error)=>{
                    logger.logError(error)
                    utils.loaded()
                })
            }else if(selectedDevice.manageType==='4'){
                //新税控设备管理服务器A10
                //定义数据字典
                $scope.dictData['inv_type'] = openApiInvType
                var requestData = {
                    taxNo: $scope.pageState.userInfo.sale.saleCreditCode,
                    machineCode: selectedDevice.diskNo
                }
                httpRequest.post_queryInvoiceInventory(requestData).then((res)=>{
                    if(res.data.success){
                        const _resData = []
                        try{
                            $scope.totalItems = res.data.value.length
                            for (let i = 0; i < $scope.totalItems; i++) {
                                var _item = res.data.value[i]
                                var item = {
                                    ukeyName: '',
                                    invType: _item.invoiceLine,
                                    invoiceCode: _item.typeCode,
                                    invoiceNumber: _item.invoiceNumStart,
                                    sum: _item.remainNum
                                }
                                _resData.push(item)
                            }
                            $scope.resData = _resData
                            $scope.selectedHandle(true)
                        }catch (e) {
                            console.log('处理异常' + e)
                        }
                    }
                    utils.loaded()
                },(error)=>{
                    logger.logError(error)
                    utils.loaded()
                })
            } else{
                //其他方式默认调用客户端soap
                searchDiskStock().then(() => {
                    const _resData = []
                    const {
                        param
                    } = $scope
                    // 汇总总数
                    $scope.totalItems = $scope.resDataTotal.length
                    for (let i = 0; i < $scope.totalItems; i++) {
                        if (i >= param.pageNum * param.pageSize || i < (param.pageNum - 1) * param.pageSize) {
                            continue
                        }
                        _resData.push($scope.resDataTotal[i])
                    }
                    $scope.resData = _resData
                    $scope.selectedHandle(true)
                }, err => {
                    logger.logError(err)
                }).finally(() => {
                    utils.loaded()
                })
            }
        }
        /*$scope.queryTaxInfo = function () {
            // 开始搜索
            // $scope.searchLoopDone = false
            // 搜索节流
            // if (searched) {
            //     return
            // }
            // searched = true
            // 搜索初始化
            // const {
            //     diskCodeList
            // } = $scope.param.param
            // const diskLen = diskCodeList.length
            // // 判断是否有金税盘
            // if (diskLen === 0) {
            //     logger.logError('请选择开票机号再查询!')
            //     searched = false
            //     return
            // }
            $scope.resData = []
            $scope.resDataTotal = []

            if (!invoiceOpenService.checkIsA9($scope.param.param.ukeyId) && checkSoapBeforeTaxCore()) return
            utils.loading('数据查询中')

            searchDiskStock().then(() => {
                const _resData = []
                const {
                    param
                } = $scope
                // 汇总总数
                $scope.totalItems = $scope.resDataTotal.length
                for (let i = 0; i < $scope.totalItems; i++) {
                    if (i >= param.pageNum * param.pageSize || i < (param.pageNum - 1) * param.pageSize) {
                        continue
                    }
                    _resData.push($scope.resDataTotal[i])
                }
                $scope.resData = _resData
                $scope.selectedHandle(true)
            }, err => {
                logger.logError(err)
            }).finally(() => {
                utils.loaded()
            })
        }*/
        //$scope.queryTaxInfo()
        // 单机版且非C48盘走校验逻辑
        // function hasSomeSingleStatus(arr) {
        //     const o = arr
        //     let fl = false
        //     for (const m in o) {
        //         if (o[m].hasOwnProperty('manageType') && o[m].hasOwnProperty('serverName') && o[m].manageType === 2 && o[m].serverName !== 'C48') {
        //             fl = true
        //             break
        //         }
        //     }
        //     return fl
        // }

        // 读取金税盘信息
        // function readDiskOpen() {
        //     const deferred = $q.defer()
        //     window.top.TaxCore.tax.invInfo(0, (data) => {
        //         if (data != null) {
        //             if (data.retcode == -1) {
        //                 deferred.reject(data.retmsg)
        //                 return
        //             }
        //             deferred.resolve(data)
        //         } else {
        //             logger.logError('读取金税盘失败,为了不影响您的开票操作，确保金税盘启用后，重新刷新页面!')
        //         }
        //     }, '', '', 0)
        //     return deferred.promise
        // }
        // 搜索金税盘队列
        // function searchDiskStockLoop(arr, index) {
        //     const diskArr = arr
        //     const disk = diskArr[index]
        //     const len = arr.length
        //     searching = layer.msg(`${disk.ukeyName}搜索中`, {
        //         time: 0,
        //         skin: 'layer-loading-self',
        //         icon: 16,
        //         shade: 0.5,
        //     })
        //     if (len > 0 && index < len) {
        //         searchDiskStock(disk).then((res) => {
        //             index++
        //             if (index !== len) {
        //                 searchDiskStockLoop(diskArr, index)
        //             } else {
        //                 // 搜索可点
        //                 searched = false
        //                 layer.close(searching)
        //                 // 搜索循环结束
        //                 $scope.searchLoopDone = true
        //             }
        //         }, (err) => {
        //             index++
        //             if (index !== len) {
        //                 searchDiskStockLoop(diskArr, index)
        //             } else {
        //                 // 搜索可点
        //                 searched = false
        //                 layer.close(searching)
        //                 // 搜索循环结束
        //                 $scope.searchLoopDone = true
        //             }
        //         })
        //     }
        // }

        // 获取金税盘库存
        function searchDiskStock() {
            const deferred = $q.defer()
            invoiceOpenService.getStockByUkey(
                $scope.ukeyList,
                $scope.param.param.ukeyId,
                $scope.param.param.invoiceType
            ).then(res => {
                if (!$scope.param.param.invoiceType && !res.length) deferred.reject('未查询到发票库存信息')
                $scope.param.param.invoiceType && (res = [res])
                const ukeyObj = $scope.ukeyList.filter((item) => item.ukeyId == $scope.param.param.ukeyId)[0]
                res.forEach(i => {
                    i.ukeyName = ukeyObj.ukeyName
                    i.manageType = ukeyObj.manageType
                })
                $scope.resDataTotal = $scope.resDataTotal.concat(res)
                deferred.resolve(1)
            }, err => {
                deferred.reject(err)
            })
            return deferred.promise
        }


        // // 查询回调处理
        // function kcWritebackOpen(data) {
        //     const invType = $scope.param.param.invoiceType
        //     // 筛选其他条件
        //     // 判断查询类型

        //     if (data.manageType === 2) {
        //         //  单机版返回
        //         if (invType !== '') {
        //             const _billArry = data.billArry.filter((item) => item.invType == invType)
        //             $scope.resDataTotal = $scope.resDataTotal.concat(_billArry)
        //         } else {
        //             $scope.resDataTotal = $scope.resDataTotal.concat(data.billArry)
        //         }
        //     } else {
        //         // 服务器版返回
        //         const _volumes = $.parseXML(data.reportXml)
        //         const volumes = $(_volumes).find('Volumes Volume')
        //         const {
        //             param
        //         } = $scope
        //         const serverRes = []
        //         const serverResLen = volumes.length

        //         if (serverResLen > 0) {
        //             volumes.each(function (index) {
        //                 // if (index >= param.pageNum * param.pageSize || index < (param.pageNum - 1) * param.pageSize) {
        //                 //     return true
        //                 // }
        //                 const self = $(this)
        //                 const Machine = self.find('Machine').text()
        //                 const invType = self.find('InvKind').text()
        //                 const Count = self.find('Count').text()
        //                 let invoiceNumber = self.find('StartNO').text()
        //                 const TypeCode = self.find('TypeCode').text()
        //                 const sum = self.find('Remain').text()
        //                 const {
        //                     manageType
        //                 } = data
        //                 let {
        //                     ukeyName
        //                 } = data

        //                 if (invoiceNumber.length < 8) {
        //                     invoiceNumber = '00000000'.slice(invoiceNumber.length) + invoiceNumber
        //                 }

        //                 if (Machine && Machine !== '0') {
        //                     $scope.ukeyList.forEach((val) => {
        //                         if (val.ukeyCode === Machine && data.diskCode === val.diskCode) {
        //                             ukeyName = `${ukeyName}/${val.ukeyName}`
        //                         }
        //                     })
        //                 }

        //                 const volumeLine = {
        //                     Machine, // 终端号
        //                     invType, // 发票种类
        //                     Count, // 发票分数
        //                     invoiceNumber, // 起始号码
        //                     sum, // 剩余张数
        //                     invoiceCode: TypeCode, // 类别代码
        //                     manageType, // 金税盘类型
        //                     ukeyName, // 开盘机/开票点
        //                 }
        //                 // 筛选其他条件
        //                 // 发票类型
        //                 if (invType !== '') {
        //                     if (invType == invType) {
        //                         serverRes.push(volumeLine)
        //                     }
        //                 } else {
        //                     serverRes.push(volumeLine)
        //                 }
        //             })
        //             $scope.resDataTotal = $scope.resDataTotal.concat(serverRes)
        //         }
        //     }
        // }

        // $scope.$watch('searchLoopDone', (newval) => {
        //     if (newval) {
        //         const _resData = []
        //         const {
        //             param
        //         } = $scope
        //         // 汇总总数
        //         $scope.totalItems = $scope.resDataTotal.length
        //         for (let i = 0; i < $scope.totalItems; i++) {
        //             if (i >= param.pageNum * param.pageSize || i < (param.pageNum - 1) * param.pageSize) {
        //                 continue
        //             }
        //             _resData.push($scope.resDataTotal[i])
        //         }
        //         $scope.resData = _resData
        //         $scope.selectedHandle(true)
        //     }
        // })
        // 表头排序
        $scope.orderMap = initSortService()
        $scope.selectedHandle = function (haveData) {
            let list = []
            const {
                param
            } = $scope
            const {
                sortKey
            } = $scope.orderMap
            let type = 'string'
            if (sortKey == 'invoiceCode' || sortKey == 'invoiceNumber' || sortKey == 'invType' || sortKey == 'sum' || sortKey == 'manageType') {
                type = 'num'
            }
            const flag = $scope.orderMap.sortVal == 'desc' ? 1 : -1
            if (haveData) {
                list = JSON.parse(JSON.stringify($scope.resData))
                if (!list.length) return
                // list = JSON.parse(JSON.stringify(mock))
                if ($scope.orderMap.sortVal) {
                    list.sort((a, b) => querySort.compareFun(a[sortKey], b[sortKey], type) * flag)
                }
                $scope.resData = list
            } else {
                const len = $scope.resDataTotal.length
                for (let i = 0; i < len; i++) {
                    if (i >= param.pageNum * param.pageSize || i < (param.pageNum - 1) * param.pageSize) {
                        continue
                    }
                    list.push($scope.resDataTotal[i])
                }
                list = JSON.parse(JSON.stringify(list))
                if (!list.length) return
                // list = JSON.parse(JSON.stringify(mock))
                if ($scope.orderMap.sortVal) {
                    list.sort((a, b) => querySort.compareFun(a[sortKey], b[sortKey], type) * flag)
                }
                $scope.resData = list
            }
            list = JSON.parse(JSON.stringify(list))
            if (!list.length) return
            // list = JSON.parse(JSON.stringify(mock))
            if ($scope.orderMap.sortVal) {
                list.sort((a, b) => querySort.compareFun(a[sortKey], b[sortKey], type) * flag)
            }
            $scope.resData = list
        }
    }
}

declareStockCtrl.$inject = ['$scope', 'httpRequest', '$q', 'logger', '$http', 'querySort', 'initSortService', 'invoiceOpenService']
export default declareStockCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/stocks/declareStockCtrl.js